<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getMembershipTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionMembership && permissionMembership.permission_id === permission.readWrite"
          @click.native="createMembership" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable()">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort_order == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort_order == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td>{{ item.title_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>{{ item.orders }}</td>
              <td>
                <a @click="showMembership(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputTextField from "../../../components/Input/InputTextField";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
import {permissionMembership, role} from "../../../util/Permission";
import {mapState} from "vuex";
import Loading from 'vue-loading-overlay';
import Swal from 'sweetalert';
export default {
  name: "MembershipTable",
  components: {Paginate, InputSearch, IconPencil, CircleButton, InputTextField, Loading, Swal },
  data() {
    return {
      title: "Membership",
      isLoading: false,
      permission : null,
      headers: [
        { id: 2, text: "No." ,icon : null,},
        { id: 3, text: "Branch" ,icon : null,},
        { id: 4, text: "Membership" ,icon : null,},
        { id: 5, text: "Update date" ,icon : null,},
        { id: 6, text: "Order" ,icon : true,},
        { id: 7, text: "edit" ,icon : null,}
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      search : '',
      sort_order : 'desc',
    };
  },
  created() {
    this.permission = role;
    this.getMembershipTable(1);
  },
  computed: {
    permissionMembership,
  },
  methods: {
    goToMembershipEdit() {
      this.$router.push("/membership/edit");
    },
    getMembershipTable(page) {
      this.isLoading = true;
      this.$store.dispatch("Membership/getMembership", {
        page,
        search : this.search,
        sort_order : this.sort_order,
      }).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getMembershipTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    createMembership() {
      this.$store.dispatch("Membership/clearFormData").then(() => {
        this.goToMembershipEdit();
      });
    },
    showMembership(id) {
      this.isLoading = true;
      this.$store.dispatch("Membership/showMembership", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("Membership/setFormMembership", res.result).then(() => {
            this.goToMembershipEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(){
      this.sort_order = this.sort_order == 'desc' ? 'asc' : 'desc';
      this.getMembershipTable(1);
    }
  }
};
</script>

<style lang="scss" scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
